import { useEffect, useState } from "react";
import { GET_ENTERPRISE_BY_ID } from "../../../api/apiEmpresas";
import DecideHeader from "../../organisms/clientes/empresas/headers/DecideHeader";
import { PropagateLoader } from "react-spinners";
import { MdOutlineBalance } from "react-icons/md";
import { FaCoins, FaFileContract } from "react-icons/fa";
import DecideButton from "../../molecules/dashboard/DecideButton";
import { useSession } from "../../../context/SessionContext";

const EmpresaDecideTemplate = ({ id }) => {
    const { user } = useSession();
    const [loading, setLoading] = useState(false);
    const [empresa, setEmpresa] = useState();

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const empresaData = await GET_ENTERPRISE_BY_ID(id);
                setEmpresa(empresaData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [id]);

    const documentos = [
        { name: `CONTABILIDAD`, path: `/clientes/empresas/${empresa?.id}`, icon: FaCoins, disabled: !empresa?.isAccountingClient, },
        { name: `DEFENSA FISCAL`, path: `/clientes/empresas/${empresa?.id}/defensa_fiscal`, icon: MdOutlineBalance, disabled:!empresa?.isTaxDefenseClient},
    ];

    const contratos = [
        { name: "CONTRATOS", path: `/clientes/empresas/${empresa?.id}/contratos`, icon: FaFileContract },
    ];

    if (loading) return <div className="flex h-full w-full justify-center items-center"> <PropagateLoader color="red"/> </div>;

    return (
        <div className="h-full w-full space-y-2 pb-4">
            <DecideHeader empresa={empresa}/>
            <div className="h-auto w-full grid grid-cols-1 md:grid-cols-2 gap-4">
                {documentos?.map((document, index)=> (
                    <DecideButton key={index} label={document?.name} href={document?.path} icon={document?.icon} disabled={document.disabled} />
                ))}
                {user && user.role === "Admin" && contratos?.map((document, index)=> (
                    <DecideButton key={index} label={document?.name} href={document?.path} icon={document?.icon} disabled={document.disabled} />
                ))}
            </div>
        </div>
    );
};

export default EmpresaDecideTemplate;